import React from 'react';
import RuleBuilder, { emptyRecommendationSetting } from './RuleBuilder';

const RuleBuilderCreateForm = () => {
  return <RuleBuilder id={null} initialRecommendationSetting={emptyRecommendationSetting()} />;
};

export default RuleBuilderCreateForm;
